{
  "back": "Retour",
  "form": "Formulaire",
  "purposeTitle": "Quel est l'objectif de votre arrêt ?",
  "appointmentInfoTitle": "Informations sur le rendez-vous",
  "appointmentInfoHint": "Assurez-vous de remplir ce champ si vous avez un rendez-vous.",
  "checkInDetailsTitle": "Détails de l'enregistrement",
  "checkInDetailsHint": "Informations supplémentaires sur votre visite.",
  "driverPhoneLabel": "Numéro de téléphone du conducteur",
  "activateWhatsAppTitle": "Activer la messagerie WhatsApp",
  "activateWhatsAppBody": "Pour discuter avec l'entrepôt, veuillez répondre « OK » lorsque nous vous enverrons le premier message WhatsApp.",
  "whatsappDelayBanner": "Le premier message WhatsApp peut prendre jusqu'à une minute pour arriver.",
  "notesLabel": "Notes",
  "notesPlaceholder": "Instructions spéciales ou notes pour l'établissement ?",
  "addNoteToWarehouse": "Ajouter une note pour l'entrepôt",
  "verifyAndCheckIn": "Vérifier et s'enregistrer",
  "completeCheckIn": "Finaliser l'enregistrement",
  "visitGroupInbound": "Entrant",
  "visitGroupOutbound": "Sortant",
  "visitGroupBoth": "Entrant et sortant",
  "visitUnloadTruck": "Décharger mon camion",
  "visitDropTrailer": "Déposer ma remorque ou mon conteneur",
  "visitLoadTruck": "Charger mon camion",
  "visitHookTrailer": "Accrocher une remorque ou un conteneur",
  "visitUnloadLoad": "Décharger et charger mon camion",
  "visitDropHook": "Déposer et accrocher une remorque ou un conteneur",
  "containerTrailer": "Remorque",
  "containerContainer": "Conteneur",
  "containerOversized": "Surdimensionné",
  "containerOther": "Autre",
  "defaultReferenceName": "Numéro de bon de commande",
  "identifierSuffix": "{reference} ou numéro de confirmation",
  "licenseOrDotRequired": "Veuillez renseigner la plaque d'immatriculation ou le numéro DOT",
  "appointmentNotFound": "Nous n'avons pas pu localiser votre rendez-vous",
  "referenceNotFound": "Aucun rendez-vous correspondant trouvé. Les numéros de référence sont sensibles à la casse.",
  "referenceCaseSensitiveHint": "Le numéro de référence est sensible à la casse",
  "messaging": {
    "whatsappFailedTitle": "Impossible d'envoyer le message WhatsApp",
    "smsFailedTitle": "Impossible d'envoyer le message SMS",
    "whatsappFailedBody": "Nous n'avons pas pu envoyer un message à {displayPhone}. <br /><br /> Si vous vous êtes précédemment désabonné, veuillez envoyer START à <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> pour commencer à recevoir des messages de cet entrepôt.",
    "smsFailedBody": "Nous n'avons pas pu envoyer un message à {displayPhone}. <br /><br /> Si vous vous êtes précédemment désabonné, veuillez envoyer START à <a href='{smsUrl}'>{senderPhone}</a> pour commencer à recevoir des messages SMS de cet entrepôt.",
    "fallbackPhone": "le numéro de téléphone fourni"
  }
}
